/**
 * TYT gift card picker — wires the denomination radios in tyt-gift-card-buy.
 *
 * Deliberately NOT tyt-variant-picker.js. That one carries colour-thumbnail
 * mapping, a size axis and a paper axis, none of which exist on a gift card;
 * reusing it would mean defending behaviour this page cannot exercise.
 *
 * ▶ Every price string here comes from Liquid's `money` filter, rendered
 * server-side into the JSON blob. Nothing is formatted in JavaScript, so the
 * market's own currency, symbol, separator and placement are whatever Shopify
 * decided — which is the entire point of this page. Do not add a formatter.
 */
class TYTGiftCard extends HTMLElement {
  connectedCallback() {
    const dataNode = this.querySelector('[data-tyt-gc-json]');
    if (!dataNode) return;

    try {
      this.data = JSON.parse(dataNode.textContent);
    } catch (e) {
      console.warn('[tyt-gift-card] variant JSON parse failed', e);
      return;
    }
    if (!this.data || !Array.isArray(this.data.variants)) return;

    this.form = this.querySelector('[data-tyt-gc-form]');
    this.idInput = this.querySelector('[data-tyt-gc-id]');
    this.priceEl = this.querySelector('[data-tyt-gc-price]');
    this.atc = this.querySelector('[data-tyt-gc-atc]');
    if (!this.form || !this.idInput) return;

    this.form.addEventListener('change', (e) => {
      if (e.target.matches('[data-tyt-gc-radio]')) this.select(e.target);
    });
  }

  select(radio) {
    const id = Number(radio.dataset.variantId);
    const variant = this.data.variants.find((v) => v.id === id);
    if (!variant) return;

    this.idInput.value = variant.id;
    if (this.priceEl) this.priceEl.textContent = variant.price_money;
    if (this.atc) this.atc.disabled = !variant.available;

    // The selected ring is a class rather than :has(:checked) so it works in
    // browsers without :has — the guarantee-tick row sits right under it and a
    // half-supported selector there would read as a broken page.
    this.querySelectorAll('.tyt-gc__amt').forEach((el) => {
      el.classList.toggle('is-selected', el.contains(radio));
    });
  }
}

if (!customElements.get('tyt-gift-card')) {
  customElements.define('tyt-gift-card', TYTGiftCard);
}
